import React from "react";
import MainPagePresenter from "./MainPagePresenter";
import { Menu } from "../../nq-component";
import { getAllSchemasUseCase } from "../../usecases/schema/usecases";
import { getCurrentUserUseCase, signOutUseCase } from "../../usecases/user";
import { Routes, Route } from "react-router-dom";
import { OffCanvas } from "../../nq-component";
import CollectionListPage from "../collection-list/CollectionListPage";
import CollectionFormPage from "../collection-form/CollectionFormPage";
import UserApplicationListPage from "../user-applications/UserApplicationListPage";
import BasePage from "../../base/BasePage";
import NotFoundPage from "../notfound";
import { Layout, Progress, LogoHolder } from "../../nq-component";
import AccountPage from "../account/AccountPage";
import RoleFormPage from "../role-form/RoleFormPage";
import withRouter from "../../withRouter";
import DashboardPage from "../dashboard/DashboardPage";

import VerifiedApplicationListPage from "../verified-applications/VerifiedApplicationListPage";
import SellerDocumentListPage from "../seller-document-list/SellerDocumentListPage";
import ProductApprovalListPage from "../product-approval/ProductApprovalListPage";
import SubscriptionFormPage from "../subscription-form/SubscriptionFormPage";

class MainPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new MainPagePresenter(
      this,
      getCurrentUserUseCase(),
      signOutUseCase(),
      getAllSchemasUseCase()
    );
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  onClickSignOut() {
    this.presenter.onClickSignOut();
  }

  onClickMenu(e, item) {
    e.preventDefault();
    this.navigateTo(item.route);
  }

  render() {
    const user = this.getCurrentUser();
    if (this.state.loading) {
      return <Progress />;
    }
    const settings = [
      {
        name: "Edit Account",
        route: "/account",
        icon: "bi bi-person-check",
      },
    ];
    const setting = {
      name: "Settings",
      icon: "bi bi-sliders",
      route: settings,
    };

    const menus = [
      {
        name: "Users",
        route: "/collection/users",
        icon: "bi bi-people",
      },
      {
        name: "Seller Documents",
        route: "/sellerDocuments",
        icon: "bi bi-file-pdf",
      },
      {
        name: "Properties",
        route: "/collection/properties",
        label: "Property List",
        icon: "bi bi-house",
      },
    ];
    return (
      <Layout>
        <Layout.Context.Consumer>
          {(value) => (
            <OffCanvas onSetShow={value.setCollapse} show={value.collapsed}>
              <div className="offcanvas-body">
                <nav className="navbar-dark">
                  <div className="text-center">
                    <LogoHolder
                      className="bg-white"
                      textClassName="text-dark"
                      logo={user.avatar}
                      name={user.username}
                    />
                    <p className="text-white mt-3">
                      {user.name || user.username}
                    </p>
                  </div>
                  <hr className="dropdown-divider bg-light" />
                  <Menu
                    onClickItem={this.onClickMenu.bind(this)}
                    menus={menus}
                  />
                </nav>
              </div>
              <div className="m-3">
                <button
                  className="nav-link text-white btn btn-link"
                  onClick={this.onClickSignOut.bind(this)}
                >
                  <i className="bi bi-power"></i>
                  <span className="ms-2 fw-bold small">Log out</span>
                </button>
              </div>
            </OffCanvas>
          )}
        </Layout.Context.Consumer>
        <main className="vh-100 d-flex flex-column">
          <Routes>
            {/* <Route exact path={'/'} element={<DashboardPage />} /> */}
            <Route
              exact
              path={"/collection/dashboard"}
              element={<DashboardPage />}
            />
            <Route
              exact
              path={"/collection/userApplications"}
              element={<UserApplicationListPage />}
            />
            <Route
                exact
                path={"/sellerDocuments"}
                element={<SellerDocumentListPage />}
            />
            <Route
              exact
              path={"/collection/productApproval"}
              element={<ProductApprovalListPage />}
            />
            <Route
              exact
              path={"/collection/verifiedApplications"}
              element={<VerifiedApplicationListPage />}
            />
            <Route
              exact
              path={"/collection/subscription/form/:id"}
              element={<SubscriptionFormPage />}
            />
            <Route
              exact
              path={"/collection/subscription/form"}
              element={<SubscriptionFormPage />}
            />
            <Route
              exact
              path={"/collection/:name"}
              element={<CollectionListPage />}
            />
            <Route path={"/collection/roles/form"} element={<RoleFormPage />} />
            <Route
              path={"/collection/roles/form/:id"}
              element={<RoleFormPage />}
            />
            <Route
              path={"/collection/:name/form/"}
              element={<CollectionFormPage />}
            />
            <Route
              path={"/collection/:name/form/:id"}
              element={<CollectionFormPage />}
            />
            <Route path={"/account"} element={<AccountPage />} />
            <Route element={<NotFoundPage />} />
          </Routes>
        </main>
      </Layout>
    );
  }
}

export default withRouter(MainPage);
